import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../guard/auth.guard';
import { CasosDashboard } from './casos-dashboard/dash.component';
import { CasosTareasComponent } from './casos/casos.component';
import { DetalleCaso } from './detalle-caso/detalle-caso.component';
import { CasosAprobarComponent } from './casos-aprobar/casos-aprobar.component';
import { CasosArchivadosComponent } from './casos-archivados/casos-archivados.component';
import {DeteccionFraudesAprobarCasoComponent} from './detalle-caso/deteccion-fraude/aprobar-caso/aprobar-caso.component';
import { CreateBtCaseComponent } from 'src/app/modules/cases/components/create-bt-case/create-bt-case.component';

const routes: Routes = [
  {
    path: 'casos',
    component: CasosDashboard,
    canActivate: [AuthGuard],
    children: [
      { path: 'home/:case', component: CasosTareasComponent },
      { path: 'detalle/:id', component: DetalleCaso },
      { path: 'revision', component: CasosAprobarComponent },
      { path: 'revision-supervisor-deteccion-fraude', component: DeteccionFraudesAprobarCasoComponent },
      { path: 'revision-gerente-deteccion-fraude', component: DeteccionFraudesAprobarCasoComponent },
      { path: 'casosArchivados', component: CasosArchivadosComponent },
      { path: 'crear-caso/:id_case_type', component: CreateBtCaseComponent }, 
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CasosRoutingModule {}
